
import * as THREE from 'three';
import Experience from '../Experience.js';
import ElementModelManager from "../../Data/DataManagers/ElementModelManager.js";
import OBParameterManager from '../../Data/DataManagers/OBParameterManager.js';
import ClashModelManager from "../../Data/DataManagers/ClashModelManager.js";
import { CSG } from 'three-csg-ts'; // Install using npm install three-csg-ts if not already installed
import { queryBVH } from "../IFC/BoundingVolumeHierarchy.js";
import ClashModel from '../../Data/ClashModel.js';
import {getPredictedValue} from '../Network/NetworkMethods.js'
import { asyncFitOrthoPerCameraToCenteredObject } from '../Threejs/ThreeJSFunctions.js';
 



let experience = null;
let manager = new ElementModelManager()
let clashmanager = new ClashModelManager()
let parametermanager = new OBParameterManager()

// Show the popup with a custom message

export async function ReturnMeshAsGroup()
{

            const projectMeshes = manager.getModels();
            const meshgroup = new THREE.Group();
    
            projectMeshes.forEach(item =>
            {
                meshgroup.add(item.mesh);
    
    
            })
    
    
            return meshgroup;

}


export async function ifcMeshPlacer()
{

    console.log("meshplacer called")



    if (!experience) {
        experience = new Experience();
    }




    // // Check if the scene has a third child
    if (experience.world.world.scene.three.children[2]) {
        // If a third child exists, replace it with the new mesh
        experience.world.world.scene.three.remove(experience.world.world.scene.three.children[2]);
    }



    const meshgroup = new THREE.Group()

    meshgroup.name = "IFC Meshes"

    const kvplist = manager.groupByFilename();
    //console.log(kvplist)
    kvplist.forEach(item =>
    {

        const group = new THREE.Group()
        group.name = item.filename;

        item.elements.forEach(element =>{

            element.fileuid = group.uuid;

            group.add(element.mesh)

        })

        meshgroup.add(group)

    })

    experience.world.world.scene.three.add(meshgroup)

    asyncFitOrthoPerCameraToCenteredObject(experience.world.world.camera, meshgroup);

    //console.log(experience.world.world.scene.three)

    //await experience.highlighter.updateHighlighter();


}

function showPopup(message) {
    console.log("show")
    document.getElementById('popup-message').textContent = message;
    document.getElementById('popup').classList.remove('hidden-popup');
}

// Hide the popup
function hidePopup() {
    document.getElementById('popup').classList.add('hidden-popup');
}

// Attach the close button functionality
document.getElementById('popup-close-button').addEventListener('click', hidePopup);

function createClippingPlanesFromBoundingBox(mesh, margin = 0.2) {
    mesh.updateMatrixWorld(true);

    // Compute bounding box in world space
    const box = new THREE.Box3().setFromObject(mesh);
    const minWorld = box.min.clone().subScalar(margin);
    const maxWorld = box.max.clone().addScalar(margin);

    // Convert bounding box points to world space


    // Get bounding box center
    const center = new THREE.Vector3();
    box.getCenter(center).applyMatrix4(mesh.matrixWorld);

    // Define normal directions and use the CENTER for positioning
    const planes = [
        new THREE.Plane().setFromNormalAndCoplanarPoint(new THREE.Vector3(1, 0, 0), minWorld), // Left
        new THREE.Plane().setFromNormalAndCoplanarPoint(new THREE.Vector3(-1, 0, 0), maxWorld), // Right
        new THREE.Plane().setFromNormalAndCoplanarPoint(new THREE.Vector3(0, 1, 0), minWorld), // Bottom
        new THREE.Plane().setFromNormalAndCoplanarPoint(new THREE.Vector3(0, -1, 0), maxWorld), // Top
        new THREE.Plane().setFromNormalAndCoplanarPoint(new THREE.Vector3(0, 0, 1), minWorld), // Back
        new THREE.Plane().setFromNormalAndCoplanarPoint(new THREE.Vector3(0, 0, -1), maxWorld), // Front
    ];

    //console.log("Final Clipping Planes:", planes);
    return planes;
}

function visualizeClippingPlanes(scene, planes) {
    planes.forEach((plane, index) => {
        const helper = new THREE.PlaneHelper(plane, 5, 0xff0000);
        scene.add(helper);
        console.log(`Added Plane ${index}:`, plane);
    });
}

export function isolateWithClipping(mesh) {

    if (!experience) {
        experience = new Experience();
    }

    console.log(mesh)

    const renderer = experience.world.world.renderer.three;
    //console.log(experience.world.world.renderer.three)
    const clippingPlanes = createClippingPlanesFromBoundingBox(mesh, 0.2);

    console.log(clippingPlanes)
    //console.log(clippingPlanes)
    //clippingPlanes.forEach(plane => plane.negate());

    renderer.clippingPlanes = clippingPlanes;
    renderer.localClippingEnabled = true;

    //visualizeClippingPlanes(experience.world.world.scene.three, clippingPlanes);
    //console.log("Local Clipping Enabled:", renderer.localClippingEnabled);
}

export function resetClipping() {
    if (!experience) {
        experience = new Experience();
    }

    const renderer = experience.world.world.renderer.three;
    renderer.clippingPlanes = [];
    renderer.localClippingEnabled = false;
}


export function ifcTrimmer()
{

    if (!experience) {
        experience = new Experience();
    }

    const models = experience.world.world.scene.three.children.filter((child) => child.children.length > 0)

    models.forEach(child =>
        {

            let uuidlist = [];


            let newlist = child.children.filter((ch) =>
                manager.ModelIsPresent(ch.uuid)
            )

            child.children = newlist;

    })

}

export async function meshClasher() {
    if (!experience) {
        experience = new Experience();
    }

    const constructionelements = manager.GetConstructionElements();

    const progressContainer = document.getElementById("progress-container");
    const progressBar = document.getElementById("progress-bar");
    const progressText = document.getElementById("progress-text");
    const cancelButton = document.getElementById("cancel-button");

    // Show progress bar
    progressContainer.style.display = "block";

    let isCancelled = false; // Track whether the process is canceled
    let currentElementIndex = 0; // Track progress

    // Cancel button logic
    cancelButton.addEventListener("click", () => {
        isCancelled = true;
        progressContainer.style.display = "none";
        console.log("MeshClasher operation canceled.");
    });

    const clashgroup = new THREE.Group()
    clashgroup.name = experience.constants.clashlistName;
    experience.world.world.scene.three.add(clashgroup);

    for (const constructionElement of constructionelements) {
        if (isCancelled) break; // Stop execution if canceled

        //console.log(constructionElement)
        const meshA = constructionElement.mesh;
        const boxA = constructionElement.boundingBox;

        const intersectingElements = queryBVH(experience.bvhRoot, boxA);

        for (const intersectingElement of intersectingElements) {
            if (intersectingElement.filetype === "Installation") {

                //console.log(intersectingElement)
                const meshB = intersectingElement.mesh;
                const boxB = new THREE.Box3().setFromObject(meshB);
                meshA.updateMatrix(true);
                meshB.updateMatrix(true);

                const boxIntersection = boxA.clone().intersect(boxB);

                const volume = (boxIntersection.max.x - boxIntersection.min.x) *
                       (boxIntersection.max.y - boxIntersection.min.y) *
                       (boxIntersection.max.z - boxIntersection.min.z);
        
                if (volume < 0.0015) {
                    console.warn("Intersection box too small, skipping.");
                    continue;
                }
                else{

                    //console.log("We're clashing")

                    const intersectMesh = computeMeshIntersection(meshA, meshB);

                    if (intersectMesh) {
    
    
                        let clashmodel = new ClashModel(constructionElement, intersectingElement, intersectMesh, intersectMesh.uuid, parametermanager.getEmptyParameterModel());
                        console.log(clashmodel)
                        clashmodel = await setInitialParameters(clashmodel)
                        console.log(clashmodel)
                        clashmanager.addModel(clashmodel)
    
                        clashgroup.add(intersectMesh)
    
                    }

                }


            }
        }

        currentElementIndex++; // Update progress

        // Update progress bar
        const progress = Math.min(
            Math.round((currentElementIndex / constructionelements.length) * 100),
            100
        );
        progressBar.value = progress;
        progressText.textContent = `${progress}%`;

        // Allow UI to update after processing each element
        await new Promise((resolve) => setTimeout(resolve, 0));
    }

    // Hide progress bar when done
    progressContainer.style.display = "none";

    if (!isCancelled) {
        console.log("MeshClasher operation completed.");
        //await experience.highlighter.updateHighlighter();
    }
}

/**
 * Returns true if mesh boundingboxes barely touch
 * @param {THREE.Box3} boxA 
 * @param {THREE.Box3} BoxB 
 */
function MeshesBarelyTouching(boxA, BoxB)
{

}



/**
 * Computes the intersection between two meshes.
 * @param {THREE.Mesh} meshA The first mesh.
 * @param {THREE.Mesh} meshB The second mesh.
 * @returns {THREE.Mesh|null} The resulting intersection mesh or null if no intersection.
 */
function computeMeshIntersection(meshA, meshB) {
    try {
        // Perform intersection
        const intersection = CSG.intersect(meshA, meshB);

        if (
            intersection &&
            intersection.geometry &&
            intersection.geometry.attributes.position &&
            intersection.geometry.attributes.position.count > 0
        ) {
            intersection.material = new THREE.MeshBasicMaterial({ color: 0xff0000 });
            //intersection.updateMatrixWorld(true);
            return intersection;
        }

        return null; // No valid intersection found
    } catch (error) {
        console.error("Error computing mesh intersection:", error);
        return null;
    }
}



/**
 * Converts an instanced mesh into an array of individual standard meshes.
 * @param {THREE.InstancedMesh} instancedMesh The instanced mesh.
 * @returns {THREE.Mesh[]} An array of standard meshes.
 */
export function convertInstancedMeshToMeshes(instancedMesh) {
    const meshes = [];
    const dummy = new THREE.Object3D();

    if (!experience) {
        experience = new Experience();
    }




    for (let i = 0; i < instancedMesh.count; i++) {


        const position = new THREE.Vector3();
        const quaternion = new THREE.Quaternion();
        const scale = new THREE.Vector3();
        //experience.worldMatrix.decompose(position, quaternion, scale)

        instancedMesh.getMatrixAt(i, dummy.matrix);
        dummy.matrix.decompose(dummy.position, dummy.quaternion, dummy.scale);
        //instancedMesh.matrixWorld.decompose(position, quaternion, scale);


        // Clone geometry and material
        const geometryClone = instancedMesh.geometry.clone();
        //geometryClone.applyMatrix4(dummy.matrix)
        //console.log(geometryClone)


        const materialClone = cloneMaterial(instancedMesh.material);

        const mesh = new THREE.Mesh(geometryClone, materialClone);



        mesh.position.copy(dummy.position);
        mesh.quaternion.copy(dummy.quaternion);
        mesh.scale.copy(dummy.scale);

        //mesh.updateMatrixWorld(true);

        meshes.push(mesh);
    }



    return meshes;
}

/**
 * Clones a material or an array of materials.
 * @param {THREE.Material | THREE.Material[]} material The material(s) to clone.
 * @returns {THREE.Material | THREE.Material[]} The cloned material(s).
 */
function cloneMaterial(material) {
    if (Array.isArray(material)) {
        return material.map(mat => mat.clone());
    }
    return material.clone();
}

export function setMeshColor(mesh, color)
{

    if(mesh.material[0] !== undefined ){ mesh.material[0].color.setHex(color);}
    else{ mesh.material.color.setHex(color);}

}

export function getMeshColor(mesh)
{

    if(mesh.material[0] !== undefined ){return mesh.material[0].color;}
    else{return mesh.material.color;}

}

export function setMeshOpacity(mesh, opacity)
{

    if(mesh.material[0] !== undefined ){ mesh.material[0].opacity = opacity;}
    else{ mesh.material.opacity = opacity;}

}


export function convertFragmentMeshToMesh(fragmentMesh) {

    if (!experience) {
        experience = new Experience();
    }

    const newMesh = convertInstancedMeshToMeshes(fragmentMesh)[0];


    return newMesh;
}

async function setInitialParameters(clash) {

    clash.parameters.find(p => p.name === "ConstructionName").value = clash.constructionelement.name;
    clash.parameters.find(p => p.name === "ConstructionElementID").value = clash.constructionelement.id;
    clash.parameters.find(p => p.name === "ConstructionLinkedFile").value = clash.constructionelement.filePathName;
    clash.parameters.find(p => p.name === "ConstructionCategory").value = clash.constructionelement.category;

    clash.parameters.find(p => p.name === "InstallationName").value = clash.installationelement.name;
    clash.parameters.find(p => p.name === "InstallationElementID").value = clash.installationelement.id;
    clash.parameters.find(p => p.name === "InstallationLinkedFile").value = clash.installationelement.filePathName;
    clash.parameters.find(p => p.name === "InstallationCategory").value = clash.installationelement.category;

    return clash;

    
}

export async function setModelParameters()
{
    const clashmodels = clashmanager.getModels();
    console.log(clashmodels);

    const progressContainer = document.getElementById("progress-container");
    const progressBar = document.getElementById("progress-bar");
    const progressText = document.getElementById("progress-text");
    const cancelButton = document.getElementById("cancel-button");

    // Show progress bar
    progressContainer.style.display = "block";

    let isCancelled = false; // Track whether the process is canceled
    let currentElementIndex = 0; // Track progress

    // Cancel button logic
    cancelButton.addEventListener("click", () => {
        isCancelled = true;
        progressContainer.style.display = "none";
        console.log("get model parameters canceled.");
    });

    for(const clash of clashmodels)
    { 

        console.log(clash);
        if (isCancelled) break; // Stop execution if canceled

        await setParameters(clash);


        currentElementIndex++; // Update progress

        // Update progress bar
        const progress = Math.min(
            Math.round((currentElementIndex / clashmodels.length) * 100),
            100
        );
        progressBar.value = progress;
        progressText.textContent = `${progress}%`;

        // Allow UI to update after processing each element
        await new Promise((resolve) => setTimeout(resolve, 0));


    }



    progressContainer.style.display = "none";

    if (!isCancelled) {
        console.log("MeshClasher operation completed.");
        //await experience.highlighter.updateHighlighter();
    }


}

async function setParameters(clash)
{
    clash = await setConstructionInfo(clash);
    clash = await setInstallationInfo(clash);

    return clash;





    


    
}

async function setConstructionInfo(clash)
{
    console.log("setConstructionINfo()", clash)

    //let constructionparameters = clash.parameters.filter(param => param.propertyset === "Construction");

    let obparams = ["AcousticRating", "FireRating", "FireRatingOneSided", "SmokeRating", 
"ConstructionMaterial", "ConstructionName", "ConstructionThickness"]

    // Set default known values
    //constructionparameters.find(p => p.name === "ConstructionName").value = clash.constructionelement.name;
    clash.parameters.find(p => p.name === "ConstructionElementID").value = clash.constructionelement.id;
    clash.parameters.find(p => p.name === "ConstructionLinkedFile").value = clash.constructionelement.filePathName;
    clash.parameters.find(p => p.name === "ConstructionCategory").value = clash.constructionelement.category;

    // Loop through OB parameters and predict
    for (let obparam of obparams) {
        // console.log("Sending to model:", {
        // parameters: clash.constructionelement.parameters,
        // obparam,
        // filetype: "Construction"
        //     });
        
        const prediction = await getPredictedValue(
                clash.constructionelement.parameters,
                obparam,
                "Construction"

        );

        if (prediction && prediction.Construction) {
            //console.log(prediction)
            let predictedValue = prediction.Construction.value;
            let predictedParamName = prediction.Construction.parameterName;

            let targetParam = clash.parameters.find(p => p.name === obparam);
            // if(targetParam.length === 0 | targetParam === null)
            //     console.log("Could not find ", obparam, " in ", clash.parameters )
            // else
            // console.log(targetParam, predictedParamName,predictedValue)
            if (targetParam) {
                targetParam.value = predictedValue;
            } else {
                console.warn(`Parameter ${predictedParamName} not found in Construction parameters`);
            }
        }
    }

    return clash;
}

async function setInstallationInfo(clash)
{

    //let installationparameters = clash.parameters.filter(param => param.propertyset === "Installation");

    let obparams = ["InstallationHeight","InstallationInsideDiameter","InstallationMaterial","InstallationName","InstallationOutsideDiameter","InstallationSystemType","InstallationThickness","InstallationType","InstallationWidth",
"InsulationName","InsulationThickness","InsulationType"]

    //installationparameters.find(p => p.name === "InstallationName").value = clash.installationelement.name;
    clash.parameters.find(p => p.name === "InstallationElementID").value = clash.installationelement.id;
    clash.parameters.find(p => p.name === "InstallationLinkedFile").value = clash.installationelement.filePathName;
    clash.parameters.find(p => p.name === "InstallationCategory").value = clash.installationelement.category;

    for (let obparam of obparams) {
        // console.log({parameters: clash.installationelement.parameters,
        //         obparam: obparam,
        //         filetype: "Installation"})
                
                const prediction = await getPredictedValue(
                clash.installationelement.parameters,
                obparam,
                "Installation"
                
        );

        if (prediction && prediction.Installation) {
            //console.log(prediction)
            let predictedValue = prediction.Installation.value;
            let predictedParamName = prediction.Installation.parameterName;

            let targetParam = clash.parameters.find(p => p.name === obparam);
            // if(targetParam.length === 0 | targetParam === null)
            //     console.log("Could not find ", obparam, " in ", clash.parameters )
            // else
            //     console.log(targetParam, predictedParamName, predictedValue)
            if (targetParam) {
                targetParam.value = predictedValue;
            } else {
                console.warn(`Parameter ${predictedParamName} not found in Installation parameters`);
            }
        }
    }

    return clash;

}













